import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import useYouTubeApi from '../module/useYouTubeApi';

window.addEventListener('DOMContentLoaded', () => {
  enableMovieModal();
  enableOpening();
});

const lang = document.documentElement.getAttribute('lang');
const isChinese = lang === 'zh-cmn-Hant';
const isEnglish = lang === 'en';
let player = null;
let modal = null;

function enableMovieModal() {
  if (!isChinese) {
    useYouTubeApi(function() {
      player = new YT.Player('lp__movie__player', {
        videoId: isEnglish ? 'bHu4_C38gOY' : 'krAI-li-WnE',
        height: '360',
        width: '640',
        playerVars: {
          controls: 1,
          autoplay: 1,
          disablekb: 1,
          modestbranding: 1,
          enablejsapi: 1,
          iv_load_policy: 3,
          playsinline: 1,
          rel: 0,
        },
        events: {
          onReady: onPlayerReady
        },
      });

      function onPlayerReady(e) {
        e.target.mute();
        e.target.playVideo();
      }
    });
  }

  modal = document.querySelector('.lp__movie');
  const close = document.querySelector('.lp__movie__close');

  close.addEventListener('click', hide);
  modal.addEventListener('click', e => {
    if (!e.target.closest('.lp__movie__player')) {
      hide();
    }
  })

  const play = document.querySelector('.lp__kv__play');
  play.addEventListener('click', () => {
    show();
  });

  const playerArea = document.getElementById('lp__movie__player');

  function show() {
    if (isChinese) {
      playerArea.innerHTML = '<iframe src="https://player.youku.com/embed/XNjQwNDAzNDk2OA==?autoplay=true" frameBorder="0" allowfullscreen></iframe>';
    } else {
      player.playVideo();
    }

    disableBodyScroll(modal);
    modal.classList.add('-show');
  }

  function hide() {
    if (isChinese) {
      playerArea.innerHTML = '';
    } else {
      player.pauseVideo();
    }

    modal.classList.remove('-show');
    document.documentElement.style.scrollBehavior = 'auto';  // iOSでモーダルを閉じるときに、bodyが高速スクロールして戻ってくるのを一瞬で戻すようにする
    enableBodyScroll(modal);
    setTimeout(() => document.documentElement.style.scrollBehavior = '');
  }
}

function enableOpening() {
  const openingVideo = document.querySelector('.lp__opening__video');
  openingVideo.addEventListener('ended', () => {
    document.body.classList.remove('-opening');
  })
}